import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import ExitFormalitiesQueueTab from './ExitFormalitiesTab/ExitFormalitiesQueueTab';
import { setBreadCrumb } from '../../../../store/userSlice';
import FinalExitQueueTab from './FinalExitQueueTab/FinalExitQueueTab';


export default function FinalExit() {

  //screen Title Show fun
  const dispatch = useDispatch();
  const location = useLocation();
  const title = [
    { label: "FINAL EXIT", link: "/dashboard/finalexit" },
  ];
  useEffect(() => {
    dispatch(setBreadCrumb(title));
  }, []);

  //tab index
  const [index, setIndex] = useState(0);
  const handleIndex = (itemNumer) => {
    setIndex(itemNumer);
  };

  // Check if on details page
  const isDetailsPage = location.pathname.includes("/final-exit/details/");

return (
    <>
      <div className={`ml-5 mr-5`}>
        {/* Hide tabs on details page */}
        {!isDetailsPage && (
          <div className="{`flex flex-row-reverse p-10`}">
            <button
              onClick={() => handleIndex(0)}
              className={`p-2 m-1 h-10 text-black uppercase text-xs mr-2 rounded-md ${index == 0 ? "bg-blue text-white" : "bg-white text-black"}`}
            >
              EXIT FORMALITIES QUEUE
            </button>
            <button
              onClick={() => handleIndex(1)}
              className={`p-2 h-10 text-black uppercase text-xs mr-2 rounded-md ${index == 1 ? "bg-blue text-white" : "bg-white text-black"}`}
            >
              FINAL EXIT QUEUE
            </button>
          </div>
        )}
        {index === 0 ? (
          <ExitFormalitiesQueueTab setIndex={setIndex} />
        ) : index === 1 ? (
          <FinalExitQueueTab/>
        ) : index === 2 ? (
        <></>
        ) : (
          <></>
        )}
      </div>
    </>
  );
}
